'use strict';
const EXPIRATION_NAME = 'ExpirationDate';
const MINUTES_TO_EXPIRATION_DEFAULT = 1;
const BOOKING_INFO = 'bookingInfo';

const setInSessionWithExpirationTime = function(key, value, expirationInMinutes) {
    const MINUTES_TO_EXPIRATION = expirationInMinutes || MINUTES_TO_EXPIRATION_DEFAULT;
    let expirationDate = new Date();
    expirationDate.setMinutes(expirationDate.getMinutes() + MINUTES_TO_EXPIRATION);
    Odigeo.Session.set(key, JSON.stringify(value));
    Odigeo.Session.set(key + EXPIRATION_NAME, expirationDate);
};

const removeInSessionWithExpirationTime = function(key) {
    Odigeo.Session.remove(key);
    Odigeo.Session.remove(key + EXPIRATION_NAME);
};

const removeBookingInfoWithPersistBookingIdAndEmail = function(bookingInfo) {
    const {buyer: {mail}, bookingBasicInfo: {id}} = bookingInfo;
    Odigeo.Session.set(BOOKING_INFO, JSON.stringify({buyer: {mail}, bookingBasicInfo: {id}}));
    Odigeo.Session.remove(BOOKING_INFO + EXPIRATION_NAME);
};
const isKeyAndExpirationTimeValid = function(key) {
    const dataSession = Odigeo.Session.get(key);
    const dataSessionExpirationTime = new Date(Odigeo.Session.get(key + EXPIRATION_NAME));
    const now = new Date();
    return dataSession && (now.getTime() < dataSessionExpirationTime.getTime());
};

const setRedirectFromConfirmation = (deeplinkOrigin, bookingId) => {
    if (deeplinkOrigin === 'flow') {
        Odigeo.Session.set('isRedirectionFromConfirmation', bookingId);
    }
};

const refreshGeneralStatusRefresh = function(deeplinkOrigin) {
    const isRedirectionFromConfirmation = Odigeo.Utils.parseJson(Odigeo.Session.get('isRedirectionFromConfirmation'));
    const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
    const hasRefreshedFromConfirmation = Odigeo.Utils.parseJson(Odigeo.Session.get('hasRefreshedFromConfirmation'));
    if ((isRedirectionFromConfirmation === bookingInfo.bookingBasicInfo.id || deeplinkOrigin === 'flow')
    && hasRefreshedFromConfirmation?.bookingId !== bookingInfo.bookingBasicInfo.id) {
        Odigeo.Session.set('hasRefreshedFromConfirmation', JSON.stringify({bookingId: bookingInfo.bookingBasicInfo.id, shouldAvoidTagman: true}));
        location.reload();
    }
};

const removeRefreshedFromConfirmation = function() {
    const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
    const hasRefreshedFromConfirmation = Odigeo.Utils.parseJson(Odigeo.Session.get('hasRefreshedFromConfirmation'));
    if (hasRefreshedFromConfirmation && hasRefreshedFromConfirmation?.bookingId !== bookingInfo.bookingBasicInfo.id) {
        Odigeo.Session.remove('hasRefreshedFromConfirmation');
    }
};

module.exports = {
    setInSessionWithExpirationTime,
    removeBookingInfoWithPersistBookingIdAndEmail,
    removeInSessionWithExpirationTime,
    setRedirectFromConfirmation,
    isKeyAndExpirationTimeValid,
    refreshGeneralStatusRefresh,
    removeRefreshedFromConfirmation,
};
